<template>
  <div class="">
    <edit-note-template> </edit-note-template>
  </div>
</template>

<script>
import EditNoteTemplate from "@/components/profile/note-templates/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    EditNoteTemplate,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Modifica Template Nota",
        path: "note_templates.edit",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
    } else {
      this.notifyQueue({
        text: "Modifica Template Nota",
        path: "note_templates.edit",
        level: 3,
      });
    }
  },
};
</script>
